<template>
    <section class="docmain-section">
        <div class="container">
            <div class="row">
                <div class="col-lg-9">
                    <div class="docmain-container">
                        <div class="getting-details">
                            <p>{{ $t('doc.menu.Features') }}</p>
                            <img src="../../../../../assets/images/up-arrow.svg" alt="logo" class="right-arrow">

                            <p>{{ $t('doc.createChatWoodAccount.integrations') }}</p>
                            <img src="../../../../../assets/images/up-arrow.svg" alt="logo" class="right-arrow">

                            <a href="#">{{ $t('Advance.features.Integrations.Dialogflow.tittle') }}</a>
                        </div>
                        <div class="according-menu">
                            <div class="accordion" id="accordionExample">
                                <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingOne">
                                        <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">

                                            <p>{{ $t('Advance.features.Integrations.Dialogflow.') }}</p>
                                            <span class="down_up_icon"><img src="/img/up_arrow_side.7f2fb856.svg"
                                                    alt=""></span>
                                        </button>
                                    </h2>
                                    <div id="collapseOne" class="accordion-collapse collapse show"
                                        aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                        <div class="accordion-body">
                                            <div class="tableOfContents-list">
                                                <ul id="side_section_info">
                                                    <li
                                                        :class="{ 'active_menu_item': rightPanelMenuItem === '#configuring-dialogflow-integration-link' }">
                                                        <a @click="scrollTo('#configuring-dialogflow-integration')">
                                                            {{ $t('Advance.features.Integrations.Dialogflow.configure') }}</a>
                                                    </li>

                                                    <li
                                                        :class="{ 'active_menu_item': rightPanelMenuItem === '#creating-a-Dialogflow-bot-link' }">
                                                        <a @click="scrollTo('#creating-a-Dialogflow-bot')">
                                                            {{ $t('Advance.features.Integrations.Dialogflow.creating') }}</a>
                                                        <ul class="sub_menulist">
                                                            <li
                                                                :class="{ 'active_menu_item': rightPanelMenuItem === '#create-a-new-agent-link' }">
                                                                <a @click="scrollTo('#create-a-new-agent')">
                                                                    {{ $t('Advance.features.Integrations.Dialogflow.newAgent') }}</a>
                                                            </li>
                                                            <li
                                                                :class="{ 'active_menu_item': rightPanelMenuItem === '#create-intents-link' }">
                                                                <a @click="scrollTo('#create-intents')">
                                                                    {{ $t('Advance.features.Integrations.Dialogflow.intents') }} </a>
                                                            </li>
                                                            <li
                                                                :class="{ 'active_menu_item': rightPanelMenuItem === '#create-a-service-account-link' }">
                                                                <a @click="scrollTo('#create-a-service-account')">
                                                                    {{ $t('Advance.features.Integrations.Dialogflow.service') }} </a>
                                                            </li>

                                                        </ul>
                                                    </li>
                                                    <li
                                                        :class="{ 'active_menu_item': rightPanelMenuItem === '#advanced-intents-link' }">
                                                        <a @click="scrollTo('#advanced-intents')">
                                                            {{ $t('Advance.features.Integrations.Dialogflow.advance') }}</a>
                                                        <ul class="sub_menulist">
                                                            <li
                                                                :class="{ 'active_menu_item': rightPanelMenuItem === '#create-intents-link' }">
                                                                <a @click="scrollTo('#create-intents')">
                                                                    {{ $t('Advance.features.Integrations.Dialogflow.intents') }} </a>
                                                            </li>
                                                            <li
                                                                :class="{ 'active_menu_item': rightPanelMenuItem === '#interactive-messages-link' }">
                                                                <a @click="scrollTo('#interactive-messages')">
                                                                    {{ $t('Advance.features.Integrations.Dialogflow.interactiveMessages') }} </a>
                                                            </li>
                                                        </ul>
                                                    </li>

                                                    <li :class="{ 'active_menu_item': rightPanelMenuItem === '#faq-link' }"><a
                                                            @click="scrollTo('#faq')">
                                                            {{ $t('Advance.features.Integrations.Dialogflow.faq') }} </a>
                                                    <li
                                                        :class="{ 'active_menu_item': rightPanelMenuItem === '#how-can-agent-link' }">
                                                        <a @click="scrollTo('#how-can-agent')">
                                                            {{ $t('Advance.features.Integrations.Dialogflow.agentTransfer') }}</a>
                                                    </li>
                                                    </li>
                                                </ul>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="Introduction-details">

                            <div class="canned_list_wrp">
                                <h1>{{ $t('Advance.features.Integrations.Dialogflow.integrate') }}</h1>

                                <p>
                                    {{ $t('Advance.features.Integrations.Dialogflow.chatBots') }}
                                </p>
                            </div>

                            <div class="canned_list_wrp" id="configuring-dialogflow-integration">
                                <h2>
                                    {{ $t('Advance.features.Integrations.Dialogflow.configure') }}
                                </h2>

                                <blockquote>
                                    <p>{{ $t('Advance.features.Integrations.Dialogflow.note') }} <a href="#creating-a-dialogflow-bot">{{ $t('Advance.features.Integrations.Dialogflow.botSection') }}</a> {{ $t('Advance.features.Integrations.Dialogflow.first') }}</p>
                                </blockquote>

                                <p>
                                    {{ $t('Advance.features.Integrations.Dialogflow.native') }}
                                </p>

                                <p>
                                    {{ $t('Advance.features.Integrations.Dialogflow.projectKey') }}

                                </p>

                                <p class="email_wrp">
                                    <img src="../../../../../assets/images/add-to-chatwoot.webp" class="img-fuild">
                                </p>
                            </div>

                            <div class="canned_list_wrp">
                                <h2>
                                    {{ $t('Advance.features.Integrations.Dialogflow.integrationBcoor') }}

                                </h2>

                                <blockquote>
                                    <p>{{ $t('Advance.features.Integrations.Dialogflow.note') }} <a href="#creating-a-dialogflow-bot">{{ $t('Advance.features.Integrations.Dialogflow.botSection') }}</a> {{ $t('Advance.features.Integrations.Dialogflow.first') }}</p>
                                </blockquote>

                                <p>
                                    {{ $t('Advance.features.Integrations.Dialogflow.native') }}
                                </p>

                                <p>
                                    {{ $t('Advance.features.Integrations.Dialogflow.projectKey') }}

                                </p>

                                <p class="email_wrp">
                                    <img src="../../../../../assets/images/add-to-chatwoot.webp" class="img-fuild">
                                </p>

                                <p>
                                    {{ $t('Advance.features.Integrations.Dialogflow.complete') }}
                                </p>

                                <p>{{ $t('Advance.features.Integrations.Dialogflow.test') }}</p>
                            </div>

                            <div class="canned_list_wrp" id="creating-a-Dialogflow-bot">
                                <h2>
                                    {{ $t('Advance.features.Integrations.Dialogflow.creating') }}
                                </h2>

                                <p>
                                    {{ $t('Advance.features.Integrations.Dialogflow.createDialog') }}
                                </p>
                            </div>

                            <div class="canned_list_wrp" id="create-a-new-agent">
                                <h3>
                                    {{ $t('Advance.features.Integrations.Dialogflow.newAgent') }}
                                </h3>

                                <p>
                                    {{ $t('Advance.features.Integrations.Dialogflow.goTo') }} <a href="https://dialogflow.cloud.google.com" target="_blank"
                                        rel="noopener noreferrer">{{ $t('Advance.features.Integrations.Dialogflow.console') }}</a>{{ $t('Advance.features.Integrations.Dialogflow.essentials') }}
                                </p>

                                <p class="widget_wrp">
                                    <img src="../../../../../assets/images/create-new-agent.webp" class="img-fuild">
                                </p>
                            </div>

                            <div class="canned_list_wrp" id="create-intents">
                                <h3>
                                    {{ $t('Advance.features.Integrations.Dialogflow.intents') }}
                                </h3>

                                <p>
                                    {{ $t('Advance.features.Integrations.Dialogflow.projectIntents') }}
                                </p>

                                <p class="widget_wrp">
                                    <img src="../../../../../assets/images/default-intents.webp" class="img-fuild">
                                </p>
                            </div>

                            <p>
                                {{ $t('Advance.features.Integrations.Dialogflow.configuration') }}
                            </p>

                            <blockquote class="dialog_wrp">
                                <p>{{ $t('Advance.features.Integrations.Dialogflow.additional') }}<br>
                                    {{ $t('Advance.features.Integrations.Dialogflow.bcoorSupports') }} <a
                                        href="#creating-a-handoff-intent">{{ $t('Advance.features.Integrations.Dialogflow.handOff') }}</a>{{ $t('Advance.features.Integrations.Dialogflow.bracket') }} <a
                                        href="/docs/product/advanced/interactive-messages">{{ $t('Advance.features.Integrations.Dialogflow.interactiveMessages') }}</a>
                                        {{ $t('Advance.features.Integrations.Dialogflow.etc') }} <br> {{ $t('Advance.features.Integrations.Dialogflow.refer') }} <a href="#advanced-intents">{{ $t('Advance.features.Integrations.Dialogflow.advance') }}</a>
                                </p>
                            </blockquote>

                            <div class="canned_list_wrp" id="create-a-service-account">
                                <h3>
                                    {{ $t('Advance.features.Integrations.Dialogflow.service') }}
                                </h3>

                                <p>
                                    {{ $t('Advance.features.Integrations.Dialogflow.connectBot') }} <strong>{{ $t('Advance.features.Integrations.Dialogflow.project') }}</strong> {{ $t('Advance.features.Integrations.Dialogflow.bellow') }}
                                </p>

                                <p class="widget_wrp">
                                    <img src="../../../../../assets/images/project-settings.png" class="img-fuild">
                                </p>
                            </div>

                            <div class="dialog_list">
                                <p>
                                    {{ $t('Advance.features.Integrations.Dialogflow.naviagte') }} <strong>{{ $t('Advance.features.Integrations.Dialogflow.i') }} &amp; {{ $t('Advance.features.Integrations.Dialogflow.admin') }}&gt; {{ $t('Advance.features.Integrations.Dialogflow.serviceAccounts') }}</strong>{{ $t('Advance.features.Integrations.Dialogflow.like') }}
                                </p>

                                <p class="widget_wrp">
                                    <img src="../../../../../assets/images/service-account.webp" class="img-fuild">
                                </p>
                            </div>

                            <div class="dialog_list">
                                <p>{{ $t('Advance.features.Integrations.Dialogflow.description') }}</p>

                                <p class="widget_wrp">
                                    <img src="../../../../../assets/images/service-account-details.png" class="img-fuild">
                                </p>
                            </div>


                            <div class="dialog_list">
                                <p>{{ $t('Advance.features.Integrations.Dialogflow.dropdown') }}</p>

                                <p class="widget_wrp">
                                    <img src="../../../../../assets/images/service-access.webp" class="img-fuild">
                                </p>
                            </div>

                            <div class="dialog_list">

                                <p>{{ $t('Advance.features.Integrations.Dialogflow.continue') }}
                                </p>

                                <p class="widget_wrp">
                                    <img src="../../../../../assets/images/add-keys.png" class="img-fuild">
                                </p>

                                <p>
                                    {{ $t('Advance.features.Integrations.Dialogflow.json') }}
                                </p>

                            </div>

                            <div class="dialog_list" id="#advanced-intents">

                                <h2>
                                    {{ $t('Advance.features.Integrations.Dialogflow.advance') }}
                                </h2>

                                <h3 id="creating-a-handoff-intent">
                                    {{ $t('Advance.features.Integrations.Dialogflow.handoff') }}
                                </h3>

                                <p>
                                    {{ $t('Advance.features.Integrations.Dialogflow.requestFlow') }}
                                </p>

                                <p>
                                    {{ $t('Advance.features.Integrations.Dialogflow.createHandOff') }}
                                </p>

                                <div class="codeBlockContainer_I0IT language-json theme-code-block">
                                    <div class="codeBlockContent_wNvx"
                                        style="color: rgb(191, 199, 213); background-color: rgb(41, 45, 62);">
                                        <pre tabindex="0"
                                            class="prism-code language-json codeBlock_jd64 thin-scrollbar"><code class="codeBlockLines_mRuA"><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token punctuation" style="color: rgb(199, 146, 234);">{</span><span class="token plain"></span><br></span><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token plain">  </span><span class="token property">"action"</span><span class="token operator" style="color: rgb(137, 221, 255);">:</span><span class="token plain"> </span><span class="token string" style="color: rgb(195, 232, 141);">"handoff"</span><span class="token plain"></span><br></span><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token plain"></span><span class="token punctuation" style="color: rgb(199, 146, 234);">}</span><br></span></code></pre>
                                    </div>
                                </div>

                                <p class="widget_wrp">
                                    <img src="../../../../../assets/images/handoff-intent.webp" class="img-fuild">
                                </p>

                                <p>
                                    {{ $t('Advance.features.Integrations.Dialogflow.triggering') }} <code>{{ $t('Advance.features.Integrations.Dialogflow.open') }}</code> {{ $t('Advance.features.Integrations.Dialogflow.hands') }}
                                </p>

                                <blockquote>
                                    <p>
                                        {{ $t('Advance.features.Integrations.Dialogflow.moment') }}
                                    </p>
                                </blockquote>

                                <p>
                                    {{ $t('Advance.features.Integrations.Dialogflow.integration') }} <a
                                        href="/docs/product/advanced/interactive-messages">{{ $t('Advance.features.Integrations.Dialogflow.interactiveMessages') }}</a>{{ $t('Advance.features.Integrations.Dialogflow.following') }}
                                </p>

                                <div class="support_list">
                                    <ol>
                                        <li><a href="/docs/product/advanced/interactive-messages#1-options">{{ $t('Advance.features.Integrations.Dialogflow.options') }}</a>
                                            {{ $t('Advance.features.Integrations.Dialogflow.followSupport') }}</li>
                                        <li><a href="/docs/product/advanced/interactive-messages#3-cards">{{ $t('Advance.features.Integrations.Dialogflow.card') }}</a>
                                        </li>
                                        <li><a href="/docs/product/advanced/interactive-messages#4-articles">{{ $t('Advance.features.Integrations.Dialogflow.articles') }}</a>
                                        </li>
                                    </ol>
                                </div>
                            </div>

                            <div class="dialog_list">
                                <h4>
                                    {{ $t('Advance.features.Integrations.Dialogflow.interactiveMessageIntent') }}
                                </h4>

                                <p>
                                    {{ $t('Advance.features.Integrations.Dialogflow.payloadMentioned') }}
                                    <a href="/docs/product/advanced/interactive-messages">{{ $t('Advance.features.Integrations.Dialogflow.documentation') }}</a>
                                </p>

                                <p>
                                    {{ $t('Advance.features.Integrations.Dialogflow.customPayload') }}
                                </p>

                                <div class="codeBlockContainer_I0IT theme-code-block">
                                    <div class="codeBlockContent_wNvx"
                                        style="color: rgb(191, 199, 213); background-color: rgb(41, 45, 62);">
                                        <pre tabindex="0"
                                            class="prism-code language-text codeBlock_jd64 thin-scrollbar"><code class="codeBlockLines_mRuA"><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token plain">## example for an options interactive message</span><br></span><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token plain">{</span><br></span><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token plain">  "content_type": "input_select",</span><br></span><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token plain">  "content": "Select your favorite food from below",</span><br></span><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token plain">  "content_attributes": {</span><br></span><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token plain">    "items": [</span><br></span><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token plain">      {</span><br></span><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token plain">        "value": "I like sushi",</span><br></span><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token plain">        "title": "Sushi"</span><br></span><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token plain">      },</span><br></span><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token plain">      {</span><br></span><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token plain">        "title": "Biryani",</span><br></span><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token plain">        "value": "I like biryani"</span><br></span><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token plain">      },</span><br></span><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token plain">      {</span><br></span><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token plain">        "title": "Pizza",</span><br></span><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token plain">        "value": "I like pizza"</span><br></span><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token plain">      }</span><br></span><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token plain">    ]</span><br></span><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token plain">  },</span><br></span><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token plain">  "private": false</span><br></span><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token plain">}</span><br></span></code></pre>
                                    </div>
                                </div>

                                <blockquote class="dialog_wrp">
                                    <p>{{ $t('Advance.features.Integrations.Dialogflow.intentRequired') }}<br>
                                        <strong>{{ $t('Advance.features.Integrations.Dialogflow.example') }}</strong>{{ $t('Advance.features.Integrations.Dialogflow.biryani') }}
                                    </p>
                                </blockquote>
                            </div>

                            <div class="faq_section" id="faq">
                                <h2>
                                    {{ $t('Advance.features.Integrations.Dialogflow.faq') }}
                                </h2>

                                <h4 id="how-can-agent">
                                    {{ $t('Advance.features.Integrations.Dialogflow.agentTransfer') }}
                                </h4>

                                <p>
                                    {{ $t('Advance.features.Integrations.Dialogflow.connectInbox') }}
                                    <code> {{ $t('Advance.features.Integrations.Dialogflow.pending') }} </code>
                                    {{ $t('Advance.features.Integrations.Dialogflow.status') }} <code> {{ $t('Advance.features.Integrations.Dialogflow.open') }} </code>{{ $t('Advance.features.Integrations.Dialogflow.') }}{{ $t('Advance.features.Integrations.Dialogflow.intial') }} <code> {{ $t('Advance.features.Integrations.Dialogflow.handOffNew') }} </code> {{ $t('Advance.features.Integrations.Dialogflow.happens') }} <code> {{ $t('Advance.features.Integrations.Dialogflow.open') }} </code> {{ $t('Advance.features.Integrations.Dialogflow.responding') }}
                                </p>

                                <p>
                                    {{ $t('Advance.features.Integrations.Dialogflow.sometimes') }} <code>{{ $t('Advance.features.Integrations.Dialogflow.pending') }}</code> {{ $t('Advance.features.Integrations.Dialogflow.again') }}
                                </p>
                            </div>
                        </div>
                        <div class="edit-update-detail">
                            <!-- <div class="edit-pen">
                                <svg fill="currentColor" height="20" width="20" viewBox="0 0 40 40" class="iconEdit_dcUD"
                                    aria-hidden="true">
                                    <g>
                                        <path
                                            d="m34.5 11.7l-3 3.1-6.3-6.3 3.1-3q0.5-0.5 1.2-0.5t1.1 0.5l3.9 3.9q0.5 0.4 0.5 1.1t-0.5 1.2z m-29.5 17.1l18.4-18.5 6.3 6.3-18.4 18.4h-6.3v-6.2z">
                                        </path>
                                    </g>
                                </svg>
                                <a href="#">{{ $t('Advance.features.Integrations.Dialogflow.editPage') }}</a>
                            </div> -->
                            <p>{{ $t('Advance.features.Integrations.Dialogflow.lastUpdatedOn') }} <span class="dark"> {{ $t('Advance.features.Integrations.Dialogflow.date') }} </span> {{ $t('Advance.features.Integrations.Dialogflow.by') }} <span class="dark"> {{ $t('Advance.features.Integrations.Dialogflow.pranavRaj') }}</span>
                            </p>
                        </div>
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="create-chat-woot-account">
                                    <p class="preview">{{ $t('Advance.features.Integrations.Dialogflow.previous') }}</p>


                                    <router-link to="/docs/product/features/help-center/configure-ssl-for-help-center"
                                        class="introduction-account">
                                        <span>{{ $t('Advance.features.Integrations.Dialogflow.side') }}</span> {{ $t('Advance.features.Integrations.Dialogflow.introduction') }}
                                    </router-link>


                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="create-chat-woot-account">
                                    <p>{{ $t('Advance.features.Integrations.Dialogflow.next') }}</p>
                                    <router-link to="/docs/product/features/integrations/dyte">
                                        {{ $t('Advance.features.Integrations.Dialogflow.dyte') }}<span>{{ $t('Advance.features.Integrations.Dialogflow.arrow') }}</span>
                                    </router-link>

                                </div>
                            </div>
                        </div>

                    </div>
                    <div>
                        <section class="tableOfContents">
                            <div class="tableOfContents-list">
                                <ul id="side_section_info">

                                    <li
                                        :class="{ 'active_menu_item': rightPanelMenuItem === '#configuring-dialogflow-integration-link' }">
                                        <a id="#configuring-dialogflow-integration-link" @click="scrollTo('#configuring-dialogflow-integration')">
                                            {{ $t('Advance.features.Integrations.Dialogflow.configure') }}</a>
                                    </li>

                                    <li :class="{ 'active_menu_item': rightPanelMenuItem === '#creating-a-Dialogflow-bot-link' }">
                                        <a id="#creating-a-Dialogflow-bot-link" @click="scrollTo('#creating-a-Dialogflow-bot')">
                                            {{ $t('Advance.features.Integrations.Dialogflow.creating') }}</a>
                                        <ul class="sub_menulist">
                                            <li
                                                :class="{ 'active_menu_item': rightPanelMenuItem === '#create-a-new-agent-link' }">
                                                <a id="#create-a-new-agent-link" @click="scrollTo('#create-a-new-agent')">
                                                    {{ $t('Advance.features.Integrations.Dialogflow.newAgent') }}</a>
                                            </li>
                                            <li :class="{ 'active_menu_item': rightPanelMenuItem === '#create-intents-link' }"><a
                                                    id="#create-intents-link" @click="scrollTo('#create-intents')">
                                                    {{ $t('Advance.features.Integrations.Dialogflow.intents') }} </a>
                                            </li>
                                            <li
                                                :class="{ 'active_menu_item': rightPanelMenuItem === '#create-a-service-account-link' }">
                                                <a id="#create-a-service-account-link" @click="scrollTo('#create-a-service-account')">
                                                    {{ $t('Advance.features.Integrations.Dialogflow.service') }} </a>
                                            </li>

                                        </ul>
                                    </li>
                                    <li :class="{ 'active_menu_item': rightPanelMenuItem === '#creating-a-handoff-intent-link' }">
                                        <a id="#creating-a-handoff-intent-link" @click="scrollTo('#creating-a-handoff-intent')">
                                            {{ $t('Advance.features.Integrations.Dialogflow.advance') }}</a>
                                        <ul class="sub_menulist">
                                            <!-- <li :class="{ 'active_menu_item': rightPanelMenuItem === '#create-intents-link' }"><a
                                                    id="#create-intents-link" @click="scrollTo('#create-intents')">
                                                    Create intents </a></li> -->
                                            <li
                                                :class="{ 'active_menu_item': rightPanelMenuItem === '#interactive-messages-link' }">
                                                <a id="#interactive-messages-link" @click="scrollTo('#interactive-messages')">
                                                    {{ $t('Advance.features.Integrations.Dialogflow.interactiveMessages') }} </a>
                                            </li>
                                        </ul>
                                    </li>

                                    <li :class="{ 'active_menu_item': rightPanelMenuItem === '#faq-link' }"><a
                                            id="#faq-link" @click="scrollTo('#faq')">
                                            {{ $t('Advance.features.Integrations.Dialogflow.faq') }} </a>
                                    <li :class="{ 'active_menu_item': rightPanelMenuItem === '#how-can-agent-link' }">
                                        <a id="#how-can-agent-link" @click="scrollTo('#how-can-agent')">
                                            {{ $t('Advance.features.Integrations.Dialogflow.agentTransfer') }}</a>
                                    </li>
                                </li>
                                </ul>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import SideBar from "@/components/SideBar.vue";
// import MainContent from "@/components/MainContent.vue";

export default {
    name: 'ios',
    data() {
        return {
            isToggle: false,
            activeMenuItem: null,
            rightPanelMenuItem: null
        }
    },
    components: {
        Header,
        Footer,
        SideBar,
        // MainContent
    },
    mounted() {
        window.addEventListener('scroll', this.setActiveMenuItem);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.setActiveMenuItem);
    },
    methods: {
        scrollTo(selector) {
            const element = document.querySelector(selector);
            if (element) {
                const offset = 106;
                const bodyRect = document.body.getBoundingClientRect().top;
                const elementRect = element.getBoundingClientRect().top;
                const elementPosition = elementRect - bodyRect;
                const offsetPosition = elementPosition - offset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth",
                });
                this.rightPanelMenuItem = `${selector}-link`
            }
        },
        setActiveMenuItem() {
            const scrollPosition = window.scrollY;
            const menuItems = document.querySelectorAll('#side_section_info li');
            this.activeMenuItem = null
            for (let i = menuItems.length - 1; i >= 0; i--) {
                const menuItem = menuItems[i];
                // console.log(menuItem)
                const target = document.querySelector(menuItem.querySelector('a').getAttribute('id')?.replace(/-link(?=[^-]*$)/, ""));
                if ((target?.offsetTop - 200) <= scrollPosition) {
                    let tempEle
                    if (menuItem) {
                        tempEle = menuItem?.getAttribute('id')
                        let targetID = target?.getAttribute('id')
                        this.rightPanelMenuItem = `#${targetID}-link`
                        // menuItem?.classList.add("active_menu_item");
                    }
                    this.activeMenuItem = tempEle
                    return;
                }
            }
        },
        handleToggle() {
            this.isToggle = !this.isToggle
        }
    },
}
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 0px;
}
</style>